import { render } from "./UrlConfirm.vue?vue&type=template&id=070c8381&scoped=true&ts=true"
import script from "./UrlConfirm.vue?vue&type=script&lang=ts"
export * from "./UrlConfirm.vue?vue&type=script&lang=ts"

import "./UrlConfirm.vue?vue&type=style&index=0&id=070c8381&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070c8381"]])

export default __exports__